import * as Joi from "joi";
import parsePhoneNumber from 'libphonenumber-js';
import i18n from "i18n";


export const USER_EDIT_SCHEMA = Joi.object({
    fullName: Joi.string()
        .required()
        .empty('')
        .label(i18n.t("Full Name"))
        .messages({
            'any.required': `{#label} ${i18n.t("validationErrors.isRequired")}`,
        }),
    phone: Joi.string()
        .label(i18n.t("Phone"))
        .empty('')
        .required()
        .custom((value, helper) => {
            const parsedPhone = parsePhoneNumber(value, { extract: true });
            if (!parsedPhone || !parsedPhone.isValid())
                return helper.message(i18n.t("validationErrors.isValidPhone"));
            return true;
        })
        .messages({
            'any.required': `{#label} ${i18n.t("validationErrors.isRequired")}`,
        }),
    status: Joi.string()
        .valid("ACTIVE", "BLOCKED", "PENDING") // Adjust valid statuses as needed
        .required()
        .label(i18n.t("Status"))
        .messages({
            'any.required': `{#label} ${i18n.t("validationErrors.isRequired")}`,
            'any.only': `{#label} ${i18n.t("validationErrors.isValidOption")}`,
        }),
});
